import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmergencyTimesRoutingModule } from './emergency-times-routing.module';
import { EmergencyTimesComponent } from './emergency-times.component';
import { ListTimeComponent } from './list-time/list-time.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Ngx-boostrap
import { ModalModule } from 'ngx-bootstrap/modal';
import { SharedModule } from '../../shared/shared.module';

//Spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    EmergencyTimesRoutingModule,
    ModalModule.forRoot(),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule
  ],
  declarations: [
    EmergencyTimesComponent,
    ListTimeComponent
  ],
  providers:[NgxSpinnerService]
})
export class EmergencyTimesModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/emergency-times/emergency-times.module.ts